import * as React from 'react';
import { Icon } from '../../Icon';
import { IIcon } from '../../../interfaces/IIcon';

export function DashboardIcon({ width, height, viewBox, style, className }: IIcon) {
    const newViewProps = '0 0 16 17' ?? viewBox;
    return (
        <Icon
            width={width}
            height={height}
            viewBox={newViewProps}
            style={style}
            className={className}
        >
            <g>
                <path d="M14.8333 0.5H1.16667C0.523333 0.5 0 1.02333 0 1.66667V3.33333C0 3.97667 0.523333 4.5 1.16667 4.5H14.8333C15.4767 4.5 16 3.97667 16 3.33333V1.66667C16 1.02333 15.4767 0.5 14.8333 0.5Z" />
                <path d="M1.16667 16.5H6.16667C6.81 16.5 7.33333 15.9767 7.33333 15.3334V7.00004C7.33333 6.35671 6.81 5.83337 6.16667 5.83337H1.16667C0.523333 5.83337 0 6.35671 0 7.00004V15.3334C0 15.9767 0.523333 16.5 1.16667 16.5Z" />
                <path d="M14.8334 5.83337H9.83341C9.19008 5.83337 8.66675 6.35671 8.66675 7.00004V9.33337C8.66675 9.97671 9.19008 10.5 9.83341 10.5H14.8334C15.4767 10.5 16.0001 9.97671 16.0001 9.33337V7.00004C16.0001 6.35671 15.4767 5.83337 14.8334 5.83337Z" />
                <path d="M14.8334 11.8334H9.83341C9.19008 11.8334 8.66675 12.3567 8.66675 13V15.3334C8.66675 15.9767 9.19008 16.5 9.83341 16.5H14.8334C15.4767 16.5 16.0001 15.9767 16.0001 15.3334V13C16.0001 12.3567 15.4767 11.8334 14.8334 11.8334Z" />
            </g>
        </Icon>
    );
}
